export default {
  coffeeData: {
    windBreaker: "Windbrekerboom",
    horticultureInfo: "Boom in de tuinbouw",
    shadeTree: "Schaduwboom",
    coffeeVariety: "Koffievariëteit",
    coffeeSpecies: "Koffiesoorten",
    updateWindBreaker: "Windbrekerboomtype bijwerken",
    addWindBreaker: "Nieuw type windbrekerboom toevoegen",
    updateHorticultureInfo:
      "Informatie over het boomtype in de tuinbouw bijwerken",
    addHorticultureInfo:
      "Nieuwe informatie over boomtype in de tuinbouw toevoegen",
    updateShadeTree: "Schaduwboomtype bijwerken",
    addShadeTree: "Nieuw schaduwboomtype toevoegen",
    updateCoffeeVariety: "Koffievariëteit bijwerken",
    addCoffeeVariety: "Nieuw type boom van koffievariëteit toevoegen",
    deleteVarietyTitle: "Variëteit verwijderen",
    deleteVarietyMessage:
      "Weet je zeker dat je deze variëteit wilt verwijderen?",
    updateCoffeeSpecie: "Koffiesoort bijwerken",
    deleteSpecieTitle: "Soort verwijderen",
    deleteSpecieMessage: "Weet je zeker dat je deze soort wilt verwijderen?",
    addCoffeeSpecie: "Nieuwe koffiesoort toevoegen",
    variety: "Variëteit",
    selectVariety: "Variëteit selecteren",
    deleteCoffeeRecord: "Weet je zeker dat je het record wilt verwijderen?",
    deleteCoffeeData: "Koffiegegevens verwijderen",
    topicRequired: "Naam van het onderwerp is vereist",
    coffeeAddSuccess: "Koffiesoort succesvol toegevoegd.",
    treeTypeSuccess: "Boomtype succesvol toegevoegd.",
    treeTypeUpdateSuccess: "Boomtype succesvol bijgewerkt.",
    coffeeVarietySuccess: "Koffievariëteit succesvol toegevoegd.",
    coffeeSpecieSuccess: "Koffiesoort succesvol bijgewerkt.",
    nameRequired: "Naam is vereist",
    notFound: "Geen koffie-admin-gegevens gevonden",
  },
  cacaoData: {
    cacao: "Cacao",
    cacaoOverview: "Cacao Overzicht",
    cacaoVariety: "Cacao Variëteit",
    cacaoSpecies: "Cacao Soort",
    deleteCacaoData: "Cacaogegevens verwijderen",
  },
  memberDataSection: {
    import: "Importeren",
    buyingStation: "Aankoopstation",
    continue: "Doorgaan",
    farmerId: "Boerderij-ID",
    farmerName: "Naam van de boer",
    farmerAddress: "Adres van de boer",
    quality: "Kwaliteit",
    quantity: "Hoeveelheid",
    importAll: "Alles importeren",
    importSelected: "Geselecteerde importeren",
    fileLoaded: "Bestand succesvol geladen",
    incorrectHeaders: "Onjuiste koppen",
    processingBatch: "Batch verwerken",
    purchaseOrder: "Inkooporder",
    startDate: "Startdatum",
    endDate: "Einddatum",
    selectCrop: "Selecteer Gewas",
    purchasingOrder: "Inkooporder",
    totalCoffeeCherry: "Totaal koffiekers",
    airHumidity: "Luchtvochtigheid",
    density: "Dichtheid",
    temperature: "Temperatuur",
    beanMoistureContent: "Vochtgehalte van de boon",
    processType: "Procestype",
    batchRating: "Batchbeoordeling selecteren",
    purchaseDate: "Aankoopdatum",
    selectFarmer: "Boer selecteren",
    selectFarm: "Boerderij selecteren",
    selectPlantation: "Plantage selecteren",
    coffeeVariety: "Koffievariëteit",
    coffeeSpecies: "Koffiesoort",
    coffeeCherryQuantity: "Hoeveelheid koffiekers",
    coffeeCherryQuality: "Kwaliteit van koffiekers",
    coffeeType: "Koffietype",
    pricePerKg: "Prijs per kg",
    processingDone: "Verwerking voltooid",
    processedCoffeeOut: "Verwerkte koffie geleverd",
    farmer: "Boer",
    farm: "Boerderij",
    plantation: "Plantage",
    farmers: "Boeren",
    farmLimitUsed: "Limiet van boerderij gebruikt",
    phoneNumber: "Telefoonnummer",
    farmSize: "Grootte van de boerderij",
    farmLocation: "Boerderij/Locatie",
    date: "Datum",
    status: "Toestand",
    noFarmers: "Geen boeren gevonden",
    approveReject: "Goedkeuren/Afwijzen",
    farms: "Boerderijen",
    crops: "Gewassen",
    equipment: "Apparatuur",
    noFarms: "Geen boerderijen gevonden",
    views: "Weergaven",
    selectStatus: "Status selecteren",
    approved: "Goedgekeurd",
    rejected: "Afgewezen",
    reject: "Afwijzen",
    approve: "Goedkeuren",
    cancel: "Annuleren",
    add: "Toevoegen",
    describeYourReason: "Beschrijf hier uw reden",
    userInformation: "Gebruikersinformatie",
    userFarmRequest: "Boerderijaanvraag van gebruiker",
    userFarmInformation: "Boerderijinformatie van gebruiker",
    activity: "Activiteit",
    activityType: "Type activiteit",
    farmZone: "Boerderijzone",
    farmerView: "Boerenweergave",
    cropType: "Gewastype",
    cropVariety: "Variëteit van het gewas",
    area: "Gebied",
    cost: "Kosten",
    geofence: "Geofence",
    map_views: "Kaartweergaven",
    viewAllFarms: "Alle boerderijen bekijken",
    farmersDetails: "Details van de boer",
    download: "Downloaden",
    pOrder: {
      addNew: "Nieuwe toevoegen",
      viewAll: "Alles bekijken",
      selectDate: "Datum selecteren",
      makeSelection: "Maak een keuze",
      coffeeType: "Koffietype",
      enterPrice: "Prijs invoeren",
      reqPurchaseDate: "Aankoopdatum is verplicht",
      reqFarmer: "Boer is verplicht",
      reqCoffeeQnty: "Hoeveelheid koffiekers is verplicht",
      reqPrice: "Prijs per kg is verplicht",
      grandTotal: "TOTAAL",
      selectDateRange: "Selecteer datumbereik",
      import: "Importeren",
      purchaseId: "Inkoop-ID",
      purchaseDate: "Aankoopdatum",
      farmerName: "Naam van de boer",
      quality: "Kwaliteit",
      quantity: "Hoeveelheid",
      pricePerKg: "Prijs per kg",
      selectBuyingStation: "Aankoopstation selecteren",
      searchUser: "Gebruikers zoeken",
    
      // Buying Station specific translations
      buyingStations: "Aankoopstations",
      registerBuyingStation: "Aankoopstation Registreren",
      searchBuyingStation: "Zoek Aankoopstation",
      nameAndId: "Naam / ID",
      email: "Email",
      mobileNumber: "Mobiel Nummer",
      role: "Rol",
      actions: "Acties",
        view: "Bekijk",
      edit: "Bewerken",
      activate: "Activeren",
      deactivate: "Deactiveren",
      society: "Vereniging",
      operator: "Operator",
      supplier: "Leverancier",
      active: "Actief",
      deactivated: "Gedeactiveerd",
      activatedSuccessfully: "Aankoopstation succesvol geactiveerd",
      deactivatedSuccessfully: "Aankoopstation succesvol gedeactiveerd",
      deletedSuccessfully: "Aankoopstation succesvol verwijderd",
      duplicatedSuccessfully: "Aankoopstation succesvol gedupliceerd",
      confirmDialog: {
        delete: {
          title: "Aankoopstation Verwijderen",
          message: "Weet je zeker dat je dit aankoopstation wilt verwijderen?",
          confirmBtn: "Verwijderen",
        }
      }
    },
    registerNewAffiliate: "Nieuw Aankoopstation Registreren",
    selectHowYouWantToProceed: "Selecteer hoe je wilt verdergaan",
    single: "Single",
    multiple: "Multiple",
    user: "User",
    createNewAffiliate: "Nieuw Aankoopstation Registreren",
    affiliateName: "Aankoopstation Naam",
    affiliateNumber: "Aankoopstation Nummer",
    firstName: "Voornaam",
    lastName: "Achternaam",
    primaryEmailAddress: "Primaire Email Adres",
    submit: "Verzenden",
  },
};
